<template>
	<div class="roundup-row" style="margin-bottom: 25px">
		<ShareNetwork
			v-for="network in networks"
			:network="network.network"
			:key="network.network"
			:style="{
				backgroundColor: network.color,
				color: 'white',
				padding: '3px 5px',
				margin: '5px',
				borderRadius: '15px',
				width: '30px'
			}"
			:url="shareURL"
			:title="shareTitle"
			:description="shareDescription"
			:quote="shareQuote"
			:hashtags="sharing.hashtags"
			:twitterUser="sharing.twitterUser"
		>
			<i :class="network.icon"></i>
		</ShareNetwork>
	</div>
</template>

<script>
import { mapState, mapGetters } from 'vuex'

import Modal from '../../ui/Modal'
import UiButton from '../../ui/Button'

export default {
	name: 'share-tile',
	components: { Modal, UiButton },
	computed: {
		...mapState({
			home: ({ home }) => home.item,
			me: ({ me }) => me.current
		}),
		...mapGetters(['cause']),
		shareURL() {
			switch (this.cause.type) {
				case 'org':
					return this.home.institution.username
						? `https://roundup.app/p/${this.home.institution.username}?referred_by=${this.me.id}`
						: `https://app.roundupapp.com/#/register?referred_by=${this.me.id}`
				case 'group':
					return `https://app.roundupapp.com/#/Register/Group/${this.cause.uuid}?referred_by=${this.me.id}`
				default:
					return `https://app.roundupapp.com/#/Register?referred_by=${this.me.id}`
			}
		},
		shareDescription() {
			var description =
				'I’ve been donating the “rounded up” change from my purchases to support'
			if (this.cause.type === 'group') {
				description += ` a ${this.cause.name} Cause Fund `
			} else {
				description += ` ${this.cause.name} `
			}
			description +=
				'through RoundUp App. Join me and sign up today to change the world one penny at a time:'
			return description
		},
		shareQuote() {
			return this.shareDescription
		},
		shareTitle() {
			return `I’ve been donating my “rounded up” change to ${this.cause.name}`
		}
	},
	data() {
		return {
			showShareOptions: false,
			isWindows: false,
			body: '',
			sharing: {
				hashtags: 'roundup,roundupapp,roundupanddonate',
				twitterUser: 'roundupdonate'
			},
			networks: [
				{
					network: 'email',
					name: 'Email',
					icon: 'far fah fa-lg fa-envelope',
					color: '#484A50'
				},
				// {
				// 	network: 'facebook',
				// 	name: 'Facebook',
				// 	icon: 'fab fah fa-lg fa-facebook-f',
				// 	color: '#1877f2'
				// },
				{
					network: 'twitter',
					name: 'Twitter',
					icon: 'fab fah fa-lg fa-twitter',
					color: '#1da1f2'
				},
				// {
				// 	network: 'reddit',
				// 	name: 'Reddit',
				// 	icon: 'fab fah fa-lg fa-reddit-alien',
				// 	color: '#ff4500'
				// },
				{
					network: 'sms',
					name: 'SMS',
					icon: 'far fah fa-lg fa-comment-dots',
					color: '#484A50'
				}
				// {
				// 	network: 'whatsapp',
				// 	name: 'Whatsapp',
				// 	icon: 'fab fah fa-lg fa-whatsapp',
				// 	color: '#25d366'
				// }
			]
		}
	},
	mounted() {
		this.isWindows = navigator.appVersion.indexOf('Win') > 0
		this.body =
			'Hey, you should download the RoundUp App. I use it to support ' +
			this.home.institution.name +
			" by giving my extra change - I don't even think about it. Check it out: https://roundup.app/p/" +
			this.home.institution.username +
			'?referred_by=' +
			this.me.id
		if (!this.home.institution.username) {
			this.body =
				'Hey, you should download the RoundUp App. I use it to support ' +
				this.home.institution.name +
				" by giving my extra change - I don't even think about it. Check it out: https://app.roundupapp.com/#/Register?referred_by=" +
				this.me.id
		}
	}
}
</script>

<style lang="scss">
.share-button {
	margin-bottom: 20px;
	.share {
		background: rgba(0, 0, 0, 0.1);
		margin: auto;
	}
	.modal {
		color: $dark-grey;
		.modal-close span {
			color: #000;
			background: $medium-grey;
		}
		.row {
			display: flex;
			flex-direction: row;
			justify-content: space-between;
		}
	}
}
</style>
